import { detectBasePath } from './utils/pathUtils';

declare let __webpack_public_path__: string;

// eslint-disable-next-line camelcase
__webpack_public_path__ = detectBasePath();
